import { Column, Entity, JoinColumn, ManyToOne } from "typeorm";
import { AbstractEntity } from "../../../database/common-entities";
import { RoleEntity } from "./role.entity";

@Entity('ums_authentications')
export class AuthenticationEntity extends AbstractEntity {

    @Column({ name: 'subject', type: 'varchar', })
    subject: string;

    @Column('varchar', {
        name: 'username',
        length: 150,
        nullable: true
    })
    userName: string;

    @Column('varchar', {
        name: 'password',
        length: 150
    })
    password: string;

    @Column('varchar', {
        name: 'mobile_no',
        length: 150
    })
    mobileNo: string;

    @Column('varchar', {
        name: 'og_pass',
        length: 100
    })
    ogPass: string;

    @Column('boolean', { name: 'is_email_verified', nullable: true })
    isEmailVerified: boolean;

    @Column('int', { name: 'no_of_failed_login', nullable: true })
    noOfFailedLogin: number;

    @Column('datetime', {
        name: 'account_locked_on', nullable: true
    })
    accountLockedOn: string;

    @Column('varchar', { name: 'sent_otp', length: 255, nullable: true })
    sentOtp: string;

    @Column('datetime', { name: 'otp_sent_time', nullable: true })
    otpSentTime: string;

    @Column('datetime', { name: 'otp_expiry_time', nullable: true })
    otpExpiryTime: string;

    @Column('varchar', { name: 'salt', nullable: true })
    salt: string;

    @Column('varchar', { name: 'hashed_refresh_token', nullable: true })
    hashedRefreshToken: string;

    @Column({ name: 'role_id', type: 'int', nullable: true })
    roleId: number;

    @ManyToOne(() => RoleEntity)
    @JoinColumn({ name: 'role_id' })
    role: RoleEntity;

    // @OneToMany(() => DonationsEntity, (donor: DonationsEntity) => donor.authId)
    // donor: DonationsEntity[];
}